import { getSanityClient } from "@lib/sanity"
import { getFooterFromSanity } from "@lib/sanity/helpers/get-footer-from-sanity"
import { ContentPageItem, FooterSingleton } from "__generated__/sanity"
import { GetStaticPaths, GetStaticProps, NextPage } from "next"
import dynamic from "next/dynamic"
import React from "react"

const ContentPageTemplateLegal = dynamic(
  () =>
    import("@components/_content-page/TemplateLegal").then(
      (mod) => mod.ContentPageTemplateLegal,
    ),
  { ssr: true },
)

type CatchAllContentPageProps = {
  footer: FooterSingleton
  content: ContentPageItem
}

const CatchAllContentPage: NextPage<CatchAllContentPageProps> = (props) => {
  if (props.content?.template === "legal") {
    return <ContentPageTemplateLegal {...props} />
  }
  if (process.env.NODE_ENV === "development") {
    console.warn(`Unsupported template: ${props.content.template}`)
  }
  return null
}

export const getStaticProps: GetStaticProps<
  CatchAllContentPageProps,
  { slug: string | string[] }
> = async ({ preview, params }) => {
  if (!params?.slug) {
    return { notFound: true }
  }

  const urlSlug = Array.isArray(params.slug)
    ? params.slug.join("/")
    : params.slug

  const sanity = getSanityClient(preview)
  const footer = await getFooterFromSanity()
  const content: ContentPageItem[] = await sanity.fetch(
    `*[_type == "content-page-item" && urlSlug.current == "${urlSlug}"] `,
  )

  if (!content.length) {
    return { notFound: true }
  }
  return {
    props: {
      footer,
      content: content[0],
    },
  }
}

export const getStaticPaths: GetStaticPaths = async () => {
  const sanity = getSanityClient()

  const query = `*[_type == "content-page-item"] {
    urlSlug
  }`
  const pages = await sanity.fetch(query)
  // Create a paths object from the query result
  const paths = pages
    .map((page) => {
      if (!page.urlSlug?.current) {
        return null
      }
      const path = page.urlSlug.current.split("/")
      return { params: { slug: path } }
    })
    .filter((t) => t)

  return { paths, fallback: false }
}

export default CatchAllContentPage
